import { ProfilePaperless, ProfilePaperlessNormalized } from '../models/profile-paperless.model';

/**
 * A user is paperless enrollable if they have at least one Non Enrolled account (that isn't Paid in Full or Closed)
 */
export const getIsPaperlessEnrollable = (loanAccounts: ProfilePaperless[]): boolean => {
  if (!loanAccounts?.length) {
    return false;
  }

  return loanAccounts.some(
    (account) =>
      account.paperlessEnrollmentStatus === 'Not Enrolled' &&
      account.accountStatus !== 'Paid in Full' &&
      account.accountStatus !== 'Closed'
  );
};

export const getNormalizedPaperlessProfiles = (paperlessProfiles: ProfilePaperless[]) => {
  const res: ProfilePaperlessNormalized = {};
  for (const paperlessProfile of paperlessProfiles) {
    res[paperlessProfile.fullExternalAccountNumber] = paperlessProfile;
  }
  return res;
};
